import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  userPage: { data: [], total: 0, pageNum: 0, pageSize: 0, loading: false },
  mineRoles: { data: [], loading: false },
  orgRoles: { data: [], loading: false },
  userRoles: { data: [], loading: false },
  orgBrandList: { data: [], loading: false },
  userBrandList: { data: [], loading: false },
  keypair: { data: null, loading: false },
  confirm: { type: '', title: '', content: '', visible: false, loading: false },
  search: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
